import React from 'react';
import styled from 'styled-components';

import { Tab } from '@lt/components';

import { SEARCH_TYPE_NAMES } from '../Cigarette/constants';

import { getStyles } from './utils';
import type { TabsVariant } from './types';
import type { SearchType } from '../Cigarette/types';

interface SearchTypeTabProps {
  name: SearchType;
  label: string;
  altLabel?: string;
  Icon: React.MemoExoticComponent<(props: React.SVGProps<SVGSVGElement>) => JSX.Element>;
  isActive?: boolean;
  variant: TabsVariant;
  onClick?: () => null;
}

export const SearchTypeTab = ({
  name,
  label,
  altLabel,
  Icon,
  isActive,
  variant,
  onClick,
}: SearchTypeTabProps) => {
  const { mobile, page, collapsed } = variant;

  const StyledIcon = styled(Icon)<{
    $variant: TabsVariant;
    $isActive?: boolean;
  }>`
    width: 24px;
    height: 24px;
    margin-right: 4px;
    flex: 1;

    path {
      ${({ $variant, $isActive }) => getStyles('ICON', $variant, $isActive)}
    }
  `;

  return (
    <StyledTab
      onClick={onClick}
      $variant={variant}
      $isActive={isActive}
      data-value={name}
      value={name}
    >
      {collapsed && mobile ? null : <StyledIcon $variant={variant} $isActive={isActive} />}
      {(page === 'HOTEL' && altLabel) || label}
      {name === SEARCH_TYPE_NAMES.HOTEL ? <StyledNewIcon>NEW</StyledNewIcon> : null}
    </StyledTab>
  );
};

const StyledNewIcon = styled.div`
  font-weight: 50;
  letter-spacing: 0.1em;
  margin-left: 4px;
  font-size: 8px;
  color: white;
  background: linear-gradient(90deg, #ff9c41 0%, #f82c69 100%);
  border-radius: 4px;
  padding: 4px;
`;

const StyledTab = styled(Tab).attrs({ functional: true })<{
  $variant: TabsVariant;
  $isActive?: boolean;
}>`
  cursor: pointer;
  padding: 8px 16px;
  border: none;
  margin-bottom: 0;
  margin-left: 0;
  border-radius: ${({ $variant: { mobile, collapsed } }) => {
    if (!mobile) return '8px 8px 0 0';
    return collapsed ? '4px 4px 0 0' : '40px';
  }};

  ${({ $variant, $isActive }) => getStyles('TAB', $variant, $isActive)}

  button {
    display: flex;
    align-items: center;
  }
  ${({ name }) => name === 'hotel' && 'display: flex'}
`;
